import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const BookCover = ({ image = '/assets/imgs/Shop/Without_text.png', lang }) => {
  const { t, i18n } = useTranslation('cover');
  const targetLang = (lang || i18n.language || 'en').toLowerCase();
  const fixedT = useMemo(() => (key) => {
    if (lang && i18n.getFixedT) {
      const ft = i18n.getFixedT(lang, 'cover');
      return ft(key);
    }
    return t(key);
  }, [lang, i18n, t]);
  const isRTL = useMemo(() => {
    return targetLang.startsWith('ur') || targetLang.startsWith('ar');
  }, [targetLang]);

  // Approximate positions based on design: tweak as needed
  // Using CSS clamp to make sizes responsive and handle longer strings
  return (
    <div
      className="relative w-full h-full"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{ backgroundImage: `url('${image}')` }}
        aria-hidden="true"
      />

      {/* Overlay texts */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Top stack to avoid overlap */}
        <div
          className="absolute left-1/2 -translate-x-1/2 w-[90%] text-center"
          style={{ top: '6%' }}
        >
          {/* Top Title */}
          <div className="font-light" style={{ color: '#b5aa82' }}>
            <span
              className={`${isRTL ? 'tracking-normal' : 'tracking-[0.02em]'}`}
              style={{ fontSize: 'clamp(12px, 2.4vw, 18px)', lineHeight: 1.05 }}
            >
              {fixedT('titleTop')}
            </span>
          </div>

          {/* Main Title */}
          <div className="font-extrabold mt-[0.35rem]" style={{ color: '#000000' }}>
            <span
              className={`${isRTL ? 'tracking-normal' : 'tracking-[0.06em]'}`}
              style={{ fontSize: 'clamp(22px, 4.6vw, 44px)', lineHeight: 1.0 }}
            >
              {fixedT('titleMain')}
            </span>
          </div>

          {/* Bottom Title */}
          <div className="font-light mt-[0.45rem]" style={{ color: '#564d2c' }}>
            <span
              className={`${isRTL ? 'tracking-normal' : 'tracking-[0.02em]'}`}
              style={{ fontSize: 'clamp(12px, 2.6vw, 20px)', lineHeight: 1.05 }}
            >
              {fixedT('titleBottom')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookCover;
